<template>
  <el-dialog
    width="40%"
    :title="!dataForm.teamId ? '新增' : '修改'"
    :close-on-click-modal="false"
    :visible.sync="visible"
  >
    <el-form
      :model="dataForm"
      :rules="dataRule"
      ref="dataForm"
      @keyup.enter.native="dataFormSubmit()"
      label-width="90px"
    >
      <el-form-item label="团队名称" prop="teamName">
        <el-input
          v-model="dataForm.teamName"
          placeholder="请输入团队名称"
          maxlength="100"
        ></el-input>
      </el-form-item>
      <!-- <el-form-item label="所属区域" prop="districtId">
        <el-select v-model="dataForm.districtId" placeholder="请选择" style="width:100%" @change="selectItem">
          <el-option
            v-for="item in areaList"
            :key="item.districtId"
            :label="item.districtName"
            :value="item.districtId"
          >
          </el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="所属店铺" prop="storeId" >
        <el-select v-model="dataForm.storeId" placeholder="请选择" style="width:100%" @change="text" clearable>
          <el-option
            v-for="item in selectStore"
            :key="item.storeId"
            :label="item.storeName"
            :value="item.storeId"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="所属工种" prop="companyCode">
        <el-select v-model="dataForm.shop" style="width: 100%">
          <el-option label="区域一" value="0"></el-option>
          <el-option label="区域二" value="1"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="选择组员" prop="users">
        <div class="list">
          <el-tag
            class="item"
            v-for="(item, index) in dataForm.users"
            :key="index"
            type="success"
            style="margin-right: 5px;"
            >{{ item.realName }}</el-tag
          >
        </div>
        <el-button size="mini" type="primary" @click="showSelect"
          >选择</el-button
        >
      </el-form-item>
      <!-- <el-form-item label="选择组长" prop="member">
        <el-select v-model="dataForm.member" style="width: 100%">
          <el-option
            v-for="item in leaderList"
            :key="item.userId"
            :label="item.realName"
            :value="item.userId"
          >
          </el-option>
        </el-select>
      </el-form-item> -->
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>

    <!-- 选择弹窗 -->
    <el-dialog
      width="50%"
      title="选择成员"
      :visible.sync="dialogVisible"
      append-to-body
    >
      <el-transfer
        filterable
        v-model="world"
        :props="{
          key: 'userId',
          label: 'realName',
        }"
        :data="memberList"
        :titles="['未选择', '已选择']"
        :button-texts="['移除', '选择']"
      ></el-transfer>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submit()">确定</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { teamSaveAdd, teamUpdateEdit, teamUser, teamInfo } from '../api'
export default {
  props: {
    areaList:{
      type: Array,
      default: []
    },
    storeList:{
      type: Array,
      default: []
    },
  },
  data() {
    return {
      visible: false,
      dialogVisible: false,
      oldMember: [],
      dataForm: {
        districtId: "",
        districtName: "",
        storeName: "",
        teamName: "",
        users: [],
        storeId: "",
        member: ""
      },
      memberList: [],//未被选择人员
      leaderList: [],//组员列表
      dataRule: {
        teamName: [
          { required: true, message: '团队名称不能为空', trigger: 'blur' }
        ],
        // districtId: [
        //   { required: true, message: '请选择区域', trigger: 'blur' }
        // ],
        storeId: [
          { required: true, message: '请选择店铺', trigger: 'blur' }
        ]
      },
      world: [], //已选的key值
      selectStore: []
    };
  },
  mounted() {
    
  },
  // watch:{
  //   dialogVisible(newVal,oldVal){
  //     if(!newVal){
  //       this.memberList = []
  //     }
  //   }
  // },
  methods: {
    text(event) {
      this.$forceUpdate()
    },
    init(id) {
      this.dataForm.teamId = id || '';
      this.visible = true;
      this.selectStore = this.storeList;
      this.$nextTick(() => {
        this.$refs["dataForm"].resetFields();
        // this.getMember();
        if (this.dataForm.teamId) {
          teamInfo(this.dataForm.teamId).then(data => {
            if (data && data.code === 0) {
              // this.dataForm.districtId = data.sysTeam.districtId;
              this.dataForm.storeId = data.sysTeam.storeId;
              this.dataForm.teamName = data.sysTeam.teamName;
              this.dataForm.users = data.sysTeam.users || [];
              this.oldMember = data.sysTeam.users || [];
              this.dataForm.districtName = data.sysTeam.districtName;
              this.dataForm.teamId = data.sysTeam.teamId || '';
              this.leaderList = data.sysTeam.users || [];
              if(this.dataForm.users){
                this.dataForm.users.forEach(item => {
                  if(item.isLeader == 'Y'){
                    this.dataForm.member = item.userId
                  }
                })
              }
              // 初始化店铺下拉框
              this.selectStore = [];
              this.storeList.forEach(item => {
                if(item.districtId == this.dataForm.districtId){
                  this.selectStore.push(item);
                }
              })
            }else{
              this.$message.error(data.msg);
            }
          });
        }else{
          this.dataForm = {}
        }
      })
      
    },
    // 组员列表
    getMember() {
      this.memberList = [];
      teamUser().then(data => {
        if (data && data.code === 0) {
          this.memberList = data.userList;
        } else {
          this.memberList = [];
          this.$message.error(data.msg);
        }
        // 编辑显示已选
        if (this.dataForm.teamId) {
          this.memberList = this.memberList.concat(this.dataForm.users);
          this.dataForm.users.forEach((element) => {
            this.memberList.forEach((item) => {
              if (element.userId == item.userId) {
                this.world.push(item.userId);
              }
            });
          });
        }
      });
    },
    // 修改组长的isLeader
    getIsLeader() {
      if(this.dataForm.member) {
        this.dataForm.users.forEach(item => {
          if(this.dataForm.member == item.userId)
            item.isLeader = 'Y';
        })
      }
    },
    getLeader(value) {
      if(value.users){
        let leader = ''
        value.users.forEach(item => {
          if(item.isLeader == 'Y'){
            leader += ' ' + item.realName
          }
        })
        return leader;
      }
    },
    // 获取地区id
    getAreaId() {
      this.areaList.forEach(item => {
        if(this.dataForm.districtId == item.districtId){
          this.dataForm.districtName = item.districtName;
        }
      })
    },
    // 表单提交
    dataFormSubmit() {
      this.dataForm = JSON.parse(JSON.stringify(this.dataForm));
      console.log(this.dataForm)
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          this.whichStore();
          // this.getAreaId();
          // 修改组员teamId
          if(this.dataForm.users && this.dataForm.users.length > 0) {
            this.dataForm.users.forEach(item => {
              item.teamId = this.dataForm.teamId;
            })
            if(this.oldMember.length > 0){
              this.oldMember.forEach(x => {
                let have = false;
                for(let item of this.dataForm.users){
                  if(item.userId == x.userId) {
                    have = true;
                    break;
                  }
                }
                if(!have){
                  x.teamId = 0;
                  this.dataForm.users.push(x);
                }
              })
            }
          }else {
            this.dataForm.users = [];
            if(this.dataForm.teamId){
              this.oldMember.forEach(x => {
                console.log('2')
                x.teamId = 0;
                this.dataForm.users.push(x);
              })
            }
          }
          // this.getIsLeader();
          let url = this.dataForm.teamId?'/zxnl/sys/team/update':'/zxnl/sys/team/save';
          let postData = {
            storeId: this.dataForm.storeId,
            storeName: this.dataForm.storeName,
            teamName: this.dataForm.teamName,
            teamId: this.dataForm.teamId || null,
            users: this.dataForm.users || null,
          }
           //判断是添加还是编辑
          if(this.dataForm.teamId) {
            teamUpdateEdit(postData).then(data =>{
              if (data && data.code === 0) {
                this.visible = false;
                this.$message({
                  message: "操作成功",
                  type: "success",
                  duration: 300,
                  onClose: () => {
                    
                  },
                });
                this.$emit("refreshDataList");
              }else {
                this.$message.error(data.msg);
              }
            })
          }else { // 添加
            teamSaveAdd(postData).then(data =>{
              if (data && data.code === 0) {
                this.visible = false;
                this.$message({
                  message: "操作成功",
                  type: "success",
                  duration: 300,
                  onClose: () => {
                    
                  },
                });
                this.$emit("refreshDataList");
              }else {
                this.$message.error(data.msg);
              }
            })
          }
        }
      });
    },
    // 提交选择的组员
    submit() {
      this.dataForm.users = [];
      if(this.world.length > 0) {
        this.world.forEach(item => {
          this.memberList.forEach(x => {
            if(item == x.userId){
              this.dataForm.users.push(x);
            }
          })
        })
      }
      this.dialogVisible = false;
      this.leaderList = this.dataForm.users || [];
      if(this.leaderList){
        let have = '';
        this.dataForm.users.forEach(item => {
          if(item.userId == this.dataForm.member){
            have = 'yes';
          }
        })
        if(!have) this.dataForm.member = '';
      }else{
        this.dataForm.member = '';
      }
    },
    // 地区和店铺关联
    selectItem(event) {
      this.selectStore = [];
      this.dataForm.storeName = '';
      this.dataForm.storeId = '';
      this.storeList.forEach(item => {
        if(item.districtId == event){
          this.dataForm.districtName = item.districtName;
          this.dataForm.districtId = item.districtId
          this.selectStore.push(item);
        }
      })
    },
    // 根据id判断店铺
    whichStore() {
      this.storeList.forEach(x => {
        if(x.storeId == this.dataForm.storeId){
          this.dataForm.storeName = x.storeName;
        }
      })
    },
    // 删除组员
    handleClose(index) {
      this.dataForm.users.splice(index,1);
    },
    // 显示已选的组员
    showSelect() {
      this.dialogVisible = true;
      this.world = [];
      this.getMember();
      
    },
  },
};
</script>
